import { inject } from '@angular/core';
import { type ResolveFn } from '@angular/router';
import { catchError, of } from 'rxjs';

import { OnboardingApiService } from '@shared/services/onboarding-api.service';
import type { FinancialSituationChoicesResponse } from '@shared/interfaces/opportunity.interface';

export type FinancialSituationInitData = FinancialSituationChoicesResponse | null;

export const financialSituationResolver: ResolveFn<FinancialSituationInitData> = () => {
  const onboardingApi = inject(OnboardingApiService);
  return onboardingApi.getFinancialSituationChoices().pipe(catchError(() => of(null)));
};
